// extracted by mini-css-extract-plugin
module.exports = {"pill":"e_cS","cart":"e_dS","label":"e_eS","arrow":"e_fS"};